var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDimensions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_517_6678)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 14,
    x2: 22,
    y2: 14,
    stroke: "#464646",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.94531,
    y1: 2,
    x2: 5.94531,
    y2: 22,
    stroke: "#464646",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36572 11.2944L0.280933 13.6507L0.284557 13.6548L0 13.9764L2.36557 16.6501C2.73153 17.0638 3.32487 17.0638 3.69083 16.6501L3.73927 16.5954C4.10523 16.1817 4.10523 15.5111 3.73927 15.0975L2.74379 13.9723L3.73942 12.847C4.10538 12.4334 4.10538 11.7627 3.73942 11.3491L3.69098 11.2944C3.32502 10.8807 2.73168 10.8807 2.36572 11.2944Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7088 2.37279L6.30126 0.281111L6.29743 0.284436L5.97004 -1.33383e-07L3.2393 2.37247C2.82239 2.73469 2.82239 3.32195 3.2393 3.68417L3.31074 3.74623C3.72765 4.10845 4.4036 4.10845 4.82052 3.74623L5.97387 2.7442L7.12758 3.74655C7.5445 4.10877 8.22045 4.10877 8.63736 3.74655L8.7088 3.68449C9.12571 3.32227 9.12571 2.735 8.7088 2.37279Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6343 16.6502L23.7191 14.2939L23.7154 14.2897L24 13.968L21.6344 11.2943C21.2685 10.8807 20.6751 10.8807 20.3092 11.2943L20.2607 11.3491C19.8948 11.7627 19.8948 12.4333 20.2607 12.847L21.2563 13.9722L20.2606 15.0976C19.8946 15.5112 19.8946 16.1818 20.2606 16.5955L20.309 16.6502C20.675 17.0639 21.2683 17.0639 21.6343 16.6502Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23558 21.6271L5.64405 23.7189L5.64808 23.7154L5.97578 24L8.70755 21.6274C9.12452 21.2653 9.12452 20.6781 8.70755 20.316L8.63581 20.2536C8.21884 19.8915 7.54279 19.8915 7.12582 20.2536L5.97175 21.256L4.81731 20.2533C4.40034 19.8912 3.72429 19.8912 3.30732 20.2533L3.23558 20.3156C2.81861 20.6778 2.81861 21.2649 3.23558 21.6271Z",
    fill: "#464646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_517_6678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensions);
export default __webpack_public_path__ + "static/media/dimensions.2c79836f3d172c28505f2835e37a4209.svg";
export { ForwardRef as ReactComponent };